<script setup lang="ts">
/* Async Components */
const MainDialogTimeOfWorking = defineAsyncComponent(
  () => import('@/components/Main/MainDialogTimeOfWorking.vue'),
)
const MainDialogSelectCity = defineAsyncComponent(
  () => import('@/components/Main/MainDialogSelectCity.vue'),
)

const { callPopup, closePopupWorking, popupsWorking } = usePopupDialog()
</script>

<template>
  <the-dialog
    :model-value="popupsWorking.visible"
    @update:model-value="closePopupWorking"
  >
    <template v-if="callPopup">
      <main-dialog-select-city
        v-if="callPopup?.template_type === 6"
        :popup="callPopup"
      />

      <main-dialog-time-of-working
        v-else
        :popup="callPopup"
        @close-popup-working="closePopupWorking"
      />
    </template>
  </the-dialog>
</template>
